import React from 'react'
import cn from 'clsx'
import styled, { keyframes } from 'styled-components'
import { transparentize } from 'polished'

const loading = keyframes`
  100% {
    transform: translateX(100%);
  }
`

const Box = styled.div`
  position: relative;
  background-color: ${props => props.theme.palette.neutral.six};
  overflow: hidden;

  &.floating {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }

  &::after {
    display: block;
    content: '';
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    transform: translateX(-100%);
    will-change: transform;
    background: linear-gradient(90deg, transparent, ${props => transparentize(0.4, props.theme.palette.neutral.five)}, transparent);
    animation: ${loading} 1.5s infinite;
  }
`

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  floating?: boolean;
}

function LoadingBox(props: Props) {
  const { className, ...rest } = props
  return <Box {...rest} className={cn(className, { floating: props.floating })}/>
}

export default LoadingBox
